export * from './checkIfUrlPointsToExtraRewards';
